import { oneOnOneEnTranslations } from './one-on-one.en';
import { oneOnOneHeTranslations } from './one-on-one.he';

export const oneOnOneTranslations = {
  en: oneOnOneEnTranslations,
  he: oneOnOneHeTranslations,
} as const;
